import { Circle as CircleStyle, Icon, Fill, Stroke, Style, Text } from 'ol/style.js';
import { Utility } from '../Utility.js';
export { search };

/**
 * Search class
 * @param {string} nodeSearch, node with search input control
 * @param {object} mapSgs, map sgs object
 */
const search = function (nodeSearch, mapSgs, searchtoponymy, nodeSearchPolice, hashSearchNPolice, hasDistrito, idNodeDistrito, hasConcelho, idNodeConcelho, hasFreguesia, idNodeFreguesia)
{
    var searchColor = 'rgba(255,255,0,0.6)'; // Default
    if (window["searchHighlightColor"] != null && window["searchHighlightColor"] != "") {
        searchColor = window["searchHighlightColor"];
    }
    var searchFillColor = 'rgba(0, 0, 255, 0.2)'; // Default
    if (window["searchHighlightFillColor"] != null && window["searchHighlightFillColor"] != "") {
        searchColor = window["searchHighlightFillColor"];
    }

    // Administrative limits info
    this._aministrativeLimitInfo = {
        hasDistrito: hasDistrito,
        idNodeDistrito: idNodeDistrito,
        hasConcelho: hasConcelho,
        idNodeConcelho: idNodeConcelho,
        hasFreguesia: hasFreguesia,
        idNodeFreguesia: idNodeFreguesia
    }

    // Style Search highligh
    this._SearchHighlighStyles = [
            new Style({
                image: new CircleStyle({
                    radius: 10,
                    stroke: new Stroke({
                        color: searchColor,
                        width: 5
                    }),
                    fill: new Fill({
                        color: searchFillColor
                    })
                }),
                stroke: new Stroke({
                    color: searchColor,
                    width: 7
                }),
                fill: new Fill({
                    color: searchFillColor
                })
            })
     ];

    // Define this
    var mySearch = this;

    // Node to install the search
    this.NodeSearch = nodeSearch;
    this.NodeSearchId = nodeSearch + "-id";

    //Zoom search Place
    this._zoomSearchPlace = 9;

    //Zoom search
    this._zoomSearch = 13;

    // The map
    this._mapSgs = mapSgs;

    //Coord
    this._coord = null;

    // Utility
    this._utility = new Utility();

    // Properties Search Toponymy
    this._workspace = searchtoponymy.workspaceSearchToponymy;
    this._geoserver = searchtoponymy.geoserverSearchToponymy;
    this._layername = searchtoponymy.layernameSearchToponymy;
    this._layernameGeom = (this._utility.GetPropertyInfoInConfigArray(this._mapSgs._settings.configurationInfo.propertyInfo, "SEARCH_ROAD", "GEOMETRY_ROAD_LAYER", "LAYER_NAME") != undefined)?this._utility.GetPropertyInfoInConfigArray(this._mapSgs._settings.configurationInfo.propertyInfo, "SEARCH_ROAD", "GEOMETRY_ROAD_LAYER", "LAYER_NAME").value: this._layername;
    this._layernameGeomFilterColumnName = (this._utility.GetPropertyInfoInConfigArray(this._mapSgs._settings.configurationInfo.propertyInfo, "SEARCH_ROAD", "GEOMETRY_ROAD_LAYER", "FILTER_COLUMN_NAME") != undefined)?this._utility.GetPropertyInfoInConfigArray(this._mapSgs._settings.configurationInfo.propertyInfo, "SEARCH_ROAD", "GEOMETRY_ROAD_LAYER", "FILTER_COLUMN_NAME").value: "";
    this._layernameColumn = searchtoponymy.layernameSearchColumn;
    this._layernameColumnNorm = searchtoponymy.layernameSearchColumnNorm;
    this._layernamePropertyDescription = searchtoponymy.layernameSearchdescriptionNorm;
    this._layernamePropertyLevelDescription = searchtoponymy.layernameSearchLevelDescription;
    this._layernamePropertyDistrito = searchtoponymy.layernameSearchArruamentoDistrito;
    this._layernamePropertyConcelho = searchtoponymy.layernameSearchArruamentoConcelho;
    this._layernamePropertyFreguesia = searchtoponymy.layernameSearchArruamentoFreguesia;
    this._layernamepropertygeom = searchtoponymy.layernameSearchArruamentoGeom;

    // Properties search nPolice
    this._hashSearchNPolice = hashSearchNPolice;
    this._nodeSearchPolice = nodeSearchPolice;

    /**
     * Go to Search selected
     * @param {any} event jQueryUI object
     * @param {any} ui jQueryUI object
     */
    this._SearchSelected = function (event, ui) {
        event.preventDefault();
        var layerName = mySearch._layernameGeom;
        var layerInfo = mySearch._mapSgs.layerTree.FindLayerInfoOnListLayer(layerName)
        var geoserverUrl = "";
        var workspace = "";
        if(!layerInfo) {
            geoserverUrl = mySearch._geoserver;
            workspace = mySearch._workspace;
        }
        else {
            geoserverUrl = layerInfo.geoserver;
            workspace = layerInfo.workspace;
        }

        // Id Toponymy
        var idToponymy = "";
        if(ui.item.value.id)
            idToponymy =  ui.item.value.id.split('.')[1];

        if (ui.item.value.properties.type_geometry == 'line') {
            var lineLayerName = "layer_toponymy_search_line";
            if (layerInfo.workspace == "GP_MEALHADA")
                lineLayerName = "layer_toponymy_search_line_1";
            mySearch._mapSgs.SetFeaturesHighlightByCqlFilter(mySearch._workspace, lineLayerName, "/geoserver/1", true, "id_geometry == " + ui.item.value.properties.id_geometry, mySearch._SearchHighlighStyles);
        }
        else if(ui.item.value.id && ui.item.value.id.indexOf('.') >= 0) {
            if(mySearch._layernameGeomFilterColumnName != "")
            {
                // By Filter
                mySearch._mapSgs.SetFeaturesHighlightByCqlFilter(workspace, layerName, geoserverUrl, true, mySearch._layernameGeomFilterColumnName + " == '" + ui.item.value.id.split('.')[1] + "'", mySearch._SearchHighlighStyles, mySearch._layernamepropertygeom);
            }
            else
            {
                // By id
                mySearch._mapSgs.SetFeaturesHighlightByArray2(workspace, layerName, geoserverUrl, true, [ui.item.value.id.split('.')[1]], mySearch._SearchHighlighStyles, mySearch._layernamepropertygeom, true, true);
            }
        }
        else {
            var freguesiaVal = (mySearch._aministrativeLimitInfo.hasFreguesia) ? ($('#' + mySearch._aministrativeLimitInfo.idNodeFreguesia + ' option:selected').text()):"";
            var cqlFilter = mySearch._layernameColumn + " == '" + ui.item.label + "'";
            if(freguesiaVal !== null && freguesiaVal !== "") {
                cqlFilter += " AND  " + mySearch._layernamePropertyFreguesia + " = '" + freguesiaVal + "'";
            }

            mySearch._mapSgs.SetFeaturesHighlightByCqlFilter(workspace, layerName, geoserverUrl, true, mySearch._layernameColumnNorm + " == '" + ui.item.label + "'", mySearch._SearchHighlighStyles, mySearch._layernamepropertygeom);
        }
        $(mySearch.NodeSearch).val(ui.item.label);
        $(mySearch.NodeSearchId).val(idToponymy);
    }

    /**
     * Go to Search selected without go to
     * @param {any} event jQueryUI object
     * @param {any} ui jQueryUI object
     */
    this._SearchSelected2 = function (event, ui) {
        event.preventDefault();

        // Id Toponymy
        var idToponymy = "";
        if (ui.item.value.id)
            idToponymy = ui.item.value.id.split('.')[1];

        $(mySearch.NodeSearch).val(ui.item.label);
        $(mySearch.NodeSearchId).val(idToponymy);
    }

    this.setLocation = function () {
        mySearch._mapSgs.map.getView().setCenter(mySearch._coord);
        mySearch._mapSgs.map.getView().setZoom(11);
    }


    /**
     * Go to Search nPolice selected
     * @param {any} event jQueryUI object
     * @param {any} ui jQueryUI object
     */
    this._SearchNPoliceSelected = function (event, ui) {
        event.preventDefault();

        var idFreguesia = (mySearch._aministrativeLimitInfo.hasFreguesia) ? (($('#' + mySearch._aministrativeLimitInfo.idNodeFreguesia + ' option:selected').attr('value') === undefined) ? "" : $('#' + mySearch._aministrativeLimitInfo.idNodeFreguesia + ' option:selected').attr('value')): "";
        var idPlaceToSearch = $(mySearch.NodeSearchId).val();
        //var nPoliceToSearch = request.term.toUpperCase();
        var nPoliceToSearch = ui.item.label.toUpperCase();
        var getFeatureUrl = mySearch._hashSearchNPolice.geoserver + "/wfs";

        // Build query
        var nPoliceCql = mySearch._hashSearchNPolice.columnFilter + " == '" + ui.item.label + "'" +
                  ((idFreguesia === "")? "": " AND " + mySearch._hashSearchNPolice.columnIdFreguesia + " == '" + idFreguesia + "'") +
                  ((idPlaceToSearch === "")? "": " AND " + mySearch._hashSearchNPolice.columnIdAddress + " == '" + idPlaceToSearch + "'");

       mySearch._mapSgs.SetFeaturesHighlightByCqlFilter(mySearch._hashSearchNPolice.workspace, mySearch._hashSearchNPolice.layerName, mySearch._hashSearchNPolice.geoserver, true, nPoliceCql, mySearch._SearchHighlighStyles, mySearch._hashSearchNPolice.geomColumn);

        $("#" + mySearch._nodeSearchPolice).val(ui.item.label);
    }

    /**
     * Render funtion for autocomplete toponymy
     * @param {any} ul jQueryUI object
     * @param {any} item jQueryUI object
     */
    this._SearchRenderItem = function (ul, item) {
        var searchContentSelected = (item.label === item.type)? item.label:item.label + ", " + item.type;
        var title = "";
        if (item.type == "")
            searchContentSelected = item.label;
        if (item.concelho != "") {
            searchContentSelected += ", " + item.concelho;
            title = "Concelho: " + item.concelho;
        }
        if (item.freguesia != "") {
            searchContentSelected += ", " + item.freguesia;
            title += ((title === "")? "": ", ") + "Freguesia: " + item.freguesia;
        }

        return $("<li class='search-result-li' >")
            .append("<div class='search-result-place' title='" + title + "'><i class='fa fa-map-marker' aria-hidden='true'></i> " + searchContentSelected + "</div>")
            .appendTo(ul);
    }

    /**
     * Render funtion for autocomplete nPolice
     * @param {any} ul jQueryUI object
     * @param {any} item jQueryUI object
     */
    this._SearchNPoliceRenderItem = function (ul, item) {
        var searchContentSelected = item.label;

        var title = "";
        if (item.idFreguesia != "") {
            title += ((title === "")? "": ", ") + "Freguesia: " + item.idFreguesia;
        }

        return $("<li class='search-result-li' >")
            .append("<div class='search-result-place' title='" + title + "'><i class='fa fa-map-marker' aria-hidden='true'></i> " + searchContentSelected + "</div>")
            .appendTo(ul);
    }

    /**
     * Search result for autocomplete
     * @param {object} request jQueryUI object
     * @param {object} response jQueryUI object
     * @param {string} url
     */
    this._SearchResult = function (request, response, url) {
        // Wait for it
        $('.search-toponymy-spin').show();

        var distritoVal = (mySearch._aministrativeLimitInfo.hasDistrito) ? (($('#' + mySearch._aministrativeLimitInfo.idNodeDistrito + ' option:selected').val() === "") ? "" : $('#' + mySearch._aministrativeLimitInfo.idNodeDistrito + ' option:selected').text()): "";
        var concelhoVal = (mySearch._aministrativeLimitInfo.hasConcelho) ? (($('#' + mySearch._aministrativeLimitInfo.idNodeConcelho + ' option:selected').val() === "") ? "" : $('#' + mySearch._aministrativeLimitInfo.idNodeConcelho + ' option:selected').text()):"";
        var freguesiaVal = (mySearch._aministrativeLimitInfo.hasFreguesia) ? (($('#' + mySearch._aministrativeLimitInfo.idNodeFreguesia + ' option:selected').val() === "") ? "" : $('#' + mySearch._aministrativeLimitInfo.idNodeFreguesia + ' option:selected').text()) : "";

        var requestUpper = request.term.toUpperCase();

        var layergeom = mySearch._mapSgs.layerTree.FindLayerInfoOnListLayer(mySearch._layername)
        var geoserverUrl = ""; 
        var workspace = "";
        if(!layergeom) {
            geoserverUrl = mySearch._geoserver;
            workspace = mySearch._workspace;
        }
        else {
            geoserverUrl = layergeom.geoserver;
            workspace = layergeom.workspace;
        }
        var getFeatureUrl = geoserverUrl + "/wfs";

        // Build query
        var cqlFilter = mySearch._layernameColumnNorm + " ilike '%" + requestUpper + "%'";

        if (distritoVal !== null && distritoVal !== "" && mySearch._layernamePropertyDistrito != "") {
            cqlFilter += " AND  " + mySearch._layernamePropertyDistrito + " ilike '%" + distritoVal + "%'";
        }

        if (concelhoVal !== null && concelhoVal !== "" && mySearch._layernamePropertyConcelho !== "") {
            cqlFilter += " AND  " + mySearch._layernamePropertyConcelho + " like '%" + concelhoVal + "%'";
        }

        if(freguesiaVal !== null && freguesiaVal !== "" &&  mySearch._layernamePropertyFreguesia !== "") {
            cqlFilter += " AND  " + mySearch._layernamePropertyFreguesia + " like '%" + freguesiaVal + "%'";
        }

        // Call geoserver to get the feature of the layer
        var getFeature = $.ajax({
            method: "GET",
            async: true,
            url: getFeatureUrl,
            data: {
                "service": 'wfs',
                "version": '2.0.0',
                "request": 'GetFeature',
                "typeNames": workspace + ':' + mySearch._layername,
                "cql_filter": cqlFilter,
                "outputFormat": 'application/json'
            }
        });

        getFeature.done(function (data, textStatus, jqXHR) {
            if (data.features) {
                if (data.features.length > 0) {
                    response(($.map(data.features, function (feature, i) {
                        return {
                            "searchOption": "toponymy",
                            "label": mySearch._utility.CapitalizeAllString(feature.properties[mySearch._layernamePropertyDescription]),
                            "type": (mySearch._layernamePropertyLevelDescription == null || mySearch._layernamePropertyLevelDescription == ""  ? '' : mySearch._utility.CapitalizeAllString(feature.properties[mySearch._layernamePropertyLevelDescription])),  
                            "value": feature,
                            "concelho": (mySearch._layernamePropertyConcelho == null || mySearch._layernamePropertyConcelho == ""  ? '' : mySearch._utility.CapitalizeAllString(feature.properties[mySearch._layernamePropertyConcelho])),
                            "freguesia": (mySearch._layernamePropertyFreguesia == null || mySearch._layernamePropertyFreguesia == "" ? '' : mySearch._utility.CapitalizeAllString(feature.properties[mySearch._layernamePropertyFreguesia]))
                        }
                    })).slice(0, 10));
                }
                else {
                    toastr["warning"]("Nenhuma rua encontrada");
                }
            }
            else {
                toastr["warning"]("Nenhuma rua encontrada");
            }
        });

        getFeature.always(function() {
            // Stop waiting
            $('.search-toponymy-spin').hide();
        });
    }

    /**
     * Search nPolice result for autocomplete
     * @param {object} request jQueryUI object
     * @param {object} response jQueryUI object
     * @param {string} url
     */
    this._SearchNPoliceResult = function (request, response, url) {
        // Wait for it
        $('.search-npolice-spin').show();

        var idFreguesia = (mySearch._aministrativeLimitInfo.hasFreguesia) ? (($('#' + mySearch._aministrativeLimitInfo.idNodeFreguesia + ' option:selected').attr('value') === undefined) ? "" : $('#' + mySearch._aministrativeLimitInfo.idNodeFreguesia + ' option:selected').attr('value')):"";
        var idPlaceToSearch = $(mySearch.NodeSearchId).val();
        var nPoliceToSearch = request.term.toUpperCase();
        var getFeatureUrl = mySearch._hashSearchNPolice.geoserver + "/wfs";

        // Build query
        var nPoliceCql = mySearch._hashSearchNPolice.columnFilter + " like '%" + nPoliceToSearch + "%'" +
                  ((idFreguesia === "")? "": " AND " + mySearch._hashSearchNPolice.columnIdFreguesia + " == '" + idFreguesia + "'") +
                  ((idPlaceToSearch === "")? "": " AND " + mySearch._hashSearchNPolice.columnIdAddress + " == '" + idPlaceToSearch + "'");

        // Call geoserver to get the feature of the layer
        var getFeature = $.ajax({
            method: "GET",
            async: true,
            url: getFeatureUrl,
            data: {
                "service": 'wfs',
                "version": '2.0.0',
                "request": 'GetFeature',
                "typeNames": mySearch._hashSearchNPolice.workspace + ':' + mySearch._hashSearchNPolice.layerName,
                "cql_filter": nPoliceCql,
                "outputFormat": 'application/json'
            }
        });

        getFeature.done(function (data, textStatus, jqXHR) {
            if (data.features) {
                if (data.features.length > 0) {
                    response(($.map(data.features, function (feature, i) {
                        return {
                            "searchOption": "nPolice",
                            "label": mySearch._utility.CapitalizeAllString(feature.properties[mySearch._hashSearchNPolice.columnFilter]),
                            "value": feature,
                            "idFreguesia": (mySearch._hashSearchNPolice.columnIdFreguesia == null || mySearch._hashSearchNPolice.columnIdFreguesia == "" ? '' : mySearch._utility.CapitalizeAllString(feature.properties[mySearch._hashSearchNPolice.columnIdFreguesia]))
                        }
                    })).slice(0, 10));
                }
                else {
                    toastr["warning"]("Nenhuma n�mero de policia encontrada");
                }
            }
            else {
                toastr["warning"]("Nenhuma n�mero de policia encontrada");
            }
        });

        getFeature.always(function() {
            // Stop waiting
            $('.search-npolice-spin').hide();
        });
    }
}

/**
 * Create search toponymy
 * @param {bool} repeated, o alexandre que fez isto n�o se lembra!
 */
search.prototype.CreateSearchToponymy = function (repeated) {    

    if (repeated == true)
        this.setLocation();
    else{

        $(this.NodeSearch).autocomplete({
            source: this._SearchResult,
            minLength: 3,
            select: this._SearchSelected,
        }).autocomplete("instance")._renderItem = this._SearchRenderItem;
    };
}

/**
 * Create search toponymy for manager trafic sign
 * @param {bool} repeated, o alexandre que fez isto n�o se lembra!
 */
search.prototype.CreateSearchToponymy2 = function (repeated) {

    if (repeated == true)
        this.setLocation();
    else {

        $(this.NodeSearch).autocomplete({
            source: this._SearchResult,
            minLength: 3,
            select: this._SearchSelected2,
        }).autocomplete("instance")._renderItem = this._SearchRenderItem;
    };
}

/**
 * Create search nPolice
 */
search.prototype.CreateSearchNPolice = function () {    

    var SearchAutocomplete = $('#' + this._nodeSearchPolice).autocomplete({
        source: this._SearchNPoliceResult,
        minLength: 1,
        select: this._SearchNPoliceSelected,
    }).autocomplete("instance")._renderItem = this._SearchNPoliceRenderItem;
}

